import { render } from "./Sokoban.vue?vue&type=template&id=2eb8a386&scoped=true"
import script from "./Sokoban.vue?vue&type=script&lang=js"
export * from "./Sokoban.vue?vue&type=script&lang=js"

import "./Sokoban.vue?vue&type=style&index=0&id=2eb8a386&scoped=true&lang=css"
import "./Sokoban.vue?vue&type=style&index=1&id=2eb8a386&lang=css"

import exportComponent from "/home/jay/Code/dm-sokoban-leveleditor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb8a386"]])

export default __exports__